import React from 'react'
import { ReactComponent as CalendarIcon } from '../../../../assets/calendar.svg'
import { ReactComponent as ClockIcon } from '../../../../assets/clock.svg'
import { ModalFooter } from 'common/components/wizard/ModalFooter'
import { useNavigate } from 'react-router-dom'

type Step4ConfirmationNoticeProps = {
  lawyerDisplayName: string
  bookingDateTime: Date
}

export const Step4ConfirmationNotice = ({ lawyerDisplayName, bookingDateTime }: Step4ConfirmationNoticeProps) => {
  const navigate = useNavigate()
  const handleFinish = () => {
    navigate('/appointments')
  }

  return (
    <>
      <div className='flex w-full flex-col font-medium justify-center p-8'>
        <div className='flex w-full flex-col text-black'>
          <div className='flex w-full flex-col'>
            <h5 className='info-text text-sm md:text-base tracking-wide'>
              Your booking request has been proposed to:
            </h5>
            <p className='text-xs md:text-sm mt-3 text-[#37455C] font-medium'>
              {lawyerDisplayName}
            </p>
          </div>

          <div className='flex mt-6 w-full flex-col'>
            <h5 className='info-text text-sm md:text-base tracking-wide'>
              Proposed date and time:
            </h5>
            <div className='self-start flex mt-3 flex-col text-xs md:text-sm text-[#37455C] font-medium'>
              <div className='date-time flex min-h-6 items-center gap-2'>
                <CalendarIcon className='w-4 h-4' />
                <p className='date-value self-stretch my-auto'>
                  {bookingDateTime.toDateString()}
                </p>
              </div>
              <div className='date-time flex min-h-6 items-center gap-2'>
                <ClockIcon className='w-4 h-4' />
                <p className='time-value self-stretch my-auto'>
                  {bookingDateTime.toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                  })}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalFooter
        backButtonHide={true}
        handleClose={handleFinish}
        forwardButtonText='View booking'
      />
    </>
  )
}